import { create } from 'zustand';

interface UIAction {
  type: string;
  payload?: Record<string, unknown>;
}

interface UIActionState {
  pendingAction: UIAction | null;
  dispatch: (action: UIAction) => void;
  consume: () => UIAction | null;
}

export const useUIActionStore = create<UIActionState>()((set, get) => ({
  pendingAction: null,
  dispatch: (action) => set({ pendingAction: action }),
  consume: () => {
    const action = get().pendingAction;
    set({ pendingAction: null });
    return action;
  },
}));
